import React from 'react';
import { Box, Icon, Text, Title } from '@nimbus-ds/components';

function ClientSkeleton(): JSX.Element {
  return (
    <Box display="flex" flexDirection="column" gap="2">
      <Title.Skeleton as="h4" />
      <Box display="flex" flexDirection="row" gap="2">
        <Icon.Skeleton />
        <Text.Skeleton />
      </Box>
      <Box display="flex" flexDirection="row" gap="2">
        <Icon.Skeleton />
        <Text.Skeleton />
      </Box>
    </Box>
  );
}

export default ClientSkeleton;
